import { create } from 'zustand'

interface PlayerInfoStore {
    balance: number
    subtractedBalance: number | null
    winAmount: number
    winLabel: string
    isWinAmountAnimating: boolean
    isLastWin: boolean
    updateBalance: (newBalance: number) => void
    // shouldBalanceSubtractOnly: stores the exact fake balance shown by UI.
    setSubtractedBalance: (newBalance: number) => void
    // shouldBalanceSubtractOnly: subtracts a paid bet from the fake balance shown by UI.
    updateSubtractedBalance: (amount: number) => void
    updateWinAmount: (newWinAmount: number) => void
    updateWinLabel: (newLabel: string, isLastWin: boolean) => void
    updateIsWinAmountAnimating: (isAnimating: boolean) => void
}

export const usePlayerInfoStore = create<PlayerInfoStore>((set) => ({
    balance: 0,
    subtractedBalance: null,
    winAmount: 0,
    winLabel: '',
    isWinAmountAnimating: false,
    isLastWin: false,
    updateBalance: (newBalance: number) => set(() => ({ balance: newBalance })),
    // shouldBalanceSubtractOnly: stores the exact fake balance shown by UI.
    setSubtractedBalance: (newBalance: number) => set(() => ({ subtractedBalance: newBalance })),
    // shouldBalanceSubtractOnly: subtracts a paid bet from the fake balance shown by UI.
    updateSubtractedBalance: (amount: number) =>
        set((state) => ({
            subtractedBalance: Math.max((state.subtractedBalance ?? state.balance) - amount, 0),
        })),
    updateWinAmount: (newWinAmount: number) => set(() => ({ winAmount: newWinAmount })),
    updateWinLabel: (newLabel: string, isLastWin = false) => set(() => ({ winLabel: newLabel, isLastWin })),
    updateIsWinAmountAnimating: (isAnimating: boolean) => set({ isWinAmountAnimating: isAnimating }),
}))
